import { useState } from "react";
import { Link } from "react-router-dom";

const games = [
  "Auto Roulette",
  "Aviator",
  "AviatorX",
  "BlastOff",
  "Dream Catcher",
  "TeenPatti T20",
  "TeenPatti ODI",
  "Muflis TeenPatti",
  "Poker",
  // ...continue your game list
];

export default function Sidebar({open}) {

  const pageName = window.location.pathname.split("/").filter(Boolean).pop();

  return (
    <div
      className={["sidebar", open && "opensidebar"].filter(Boolean).join(" ")}
      style={{ height: "90vh" }}
    >
      <style>
        {`
@scope (.aviator-scope) {
  .wrapper .sidebar {
      margin-top: 56px;
      background: black;
      position: absolute;
      top: 0;
      left: -250px;
      width: 225px;
      height: 90%;
      padding: 20px 0;
      transition: all 0.5s ease;
      z-index: 1010;
  } 
}
.active_link {
  background:white;
  color:#0c7db1;
  border-right: 2px solid rgb(5, 68, 104);
}

.active_link_color {
   
  color:#0c7db1;
   
}

`}
      </style>
      <div className="sidebar-content">
        <ul>
          <li>
            <Link
              className={pageName == "chickenroad" ? "active_link" : ""}
              to="/tp-studio/chickenroad"
            >
              <span
                className={
                  pageName == "chickenroad" ? "item active_link_color" : "item"
                }
              >
                Chicken Road
              </span>
            </Link>
          </li>

          <li>
            <Link
              className={pageName == "aviator" ? "active_link" : ""}
              to="/tp-studio/aviator"
            >
              <span
                className={
                  pageName == "aviator" ? "item active_link_color" : "item"
                }
              >
                Aviator
              </span>
            </Link>
          </li>

          <li>
            <Link
              className={pageName == "aviatorx" ? "active_link" : ""}
              to="/tp-studio/aviatorx"
            >
              <span
                className={
                  pageName == "aviatorx" ? "item active_link_color" : "item"
                }
              >
                AviatorX
              </span>
            </Link>
          </li>

          <li>
            <Link
              className={pageName == "blastoff" ? "active_link" : ""}
              to="/tp-studio/blastoff"
            >
              <span
                className={
                  pageName == "blastoff" ? "item active_link_color" : "item"
                }
              >
                BlastOff
              </span>
            </Link>
          </li>
          <li>
            <Link
              className={pageName == "cricketx" ? "active_link" : ""}
              to="/tp-studio/cricketx"
            >
              <span
                className={
                  pageName == "cricketx" ? "item active_link_color" : "item"
                }
              >
                CricketX
              </span>
            </Link>
          </li>
          <li>
            <Link
              className={pageName == "dream-catcher" ? "active_link" : ""}
              to="/tp-studio/dream-catcher"
            >
              <span
                className={
                  pageName == "dream-catcher"
                    ? "item active_link_color"
                    : "item"
                }
              >
                Dream Catcher
              </span>
            </Link>
          </li>
          <li>
            <Link
              className={pageName == "tp20-virtual" ? "active_link" : ""}
              to="/tp-studio/tp20-virtual"
            >
              <span
                className={
                  pageName == "tp20-virtual" ? "item active_link_color" : "item"
                }
              >
                TeenPatti T20
              </span>
            </Link>
          </li>

          <li>
            <Link
              className={pageName == "teenpatti-muflis" ? "active_link" : ""}
              to="/tp-studio/teenpatti-muflis"
            >
              <span
                className={
                  pageName == "teenpatti-muflis"
                    ? "item active_link_color"
                    : "item"
                }
              >
                Muflis TeenPatti
              </span>
            </Link>
          </li>

          <li>
            <Link
              className={pageName == "roulette" ? "active_link" : ""}
              to="/tp-studio/roulette"
            >
              <span
                className={
                  pageName == "roulette" ? "item active_link_color" : "item"
                }
              >
                Roulette
              </span>
            </Link>
          </li>

          <li>
            <Link
              className={pageName == "rock-paper-scissors" ? "active_link" : ""}
              to="/tp-studio/rock-paper-scissors"
            >
              <span
                className={
                  pageName == "rock-paper-scissors"
                    ? "item active_link_color"
                    : "item"
                }
              >
                Rock Paper Scissors
              </span>
            </Link>
          </li>
          <li>
            <Link
              className={pageName == "poker" ? "active_link" : ""}
              to="/tp-studio/poker"
            >
              <span
                className={
                  pageName == "poker" ? "item active_link_color" : "item"
                }
              >
                Poker
              </span>
            </Link>
          </li>
          <li>
            <Link
              className={pageName == "sicbo" ? "active_link" : ""}
              to="/tp-studio/sicbo"
            >
              <span
                className={
                  pageName == "sicbo" ? "item active_link_color" : "item"
                }
              >
                Sic-Bo
              </span>
            </Link>
          </li>
          <li>
            <Link
              className={pageName == "andarbahar-virtual" ? "active_link" : ""}
              to="/tp-studio/andarbahar-virtual"
            >
              <span
                className={
                  pageName == "andarbahar-virtual"
                    ? "item active_link_color"
                    : "item"
                }
              >
                AndarBahar
              </span>
            </Link>
          </li>
          <li>
            <Link
              className={pageName == "hilo" ? "active_link" : ""}
              to="/tp-studio/hilo"
            >
              <span
                className={
                  pageName == "hilo" ? "item active_link_color" : "item"
                }
              >
                HiLo
              </span>
            </Link>
          </li>
          <li>
            <Link
              className={pageName == "dt-virtual" ? "active_link" : ""}
              to="/tp-studio/dt-virtual"
            >
              <span
                className={
                  pageName == "dt-virtual" ? "item active_link_color" : "item"
                }
              >
                DragonTiger
              </span>
            </Link>
          </li>

          <li>
            <Link
              className={pageName == "lucky7-virtual" ? "active_link" : ""}
              to="/tp-studio/lucky7-virtual"
            >
              <span
                className={
                  pageName == "lucky7-virtual"
                    ? "item active_link_color"
                    : "item"
                }
              >
                7UpDown
              </span>
            </Link>
          </li>
          <li>
            <Link
              className={pageName == "aaa-virtual" ? "active_link" : ""}
              to="/tp-studio/aaa-virtual"
            >
              <span
                className={
                  pageName == "aaa-virtual" ? "item active_link_color" : "item"
                }
              >
                Ammar Akbar Anthony
              </span>
            </Link>
          </li>

          <li>
            <Link
              className={pageName == "superoverT20" ? "active_link" : ""}
              to="/tp-studio/superoverT20"
            >
              <span
                className={
                  pageName == "superoverT20" ? "item active_link_color" : "item"
                }
              >
                Super Over T20
              </span>
            </Link>
          </li>

          <li>
            <Link
              className={pageName == "card32-virtual" ? "active_link" : ""}
              to="/tp-studio/card32-virtual"
            >
              <span
                className={
                  pageName == "card32-virtual"
                    ? "item active_link_color"
                    : "item"
                }
              >
                32 Cards
              </span>
            </Link>
          </li>
          <li>
            <Link
              className={pageName == "bollywood-virtual" ? "active_link" : ""}
              to="/tp-studio/bollywood-virtual"
            >
              <span
                className={
                  pageName == "bollywood-virtual"
                    ? "item active_link_color"
                    : "item"
                }
              >
                Bollywood Casino
              </span>
            </Link>
          </li>
          <li>
            <Link
              className={pageName == "race17-virtual" ? "active_link" : ""}
              to="/tp-studio/race17-virtual"
            >
              <span
                className={
                  pageName == "race17-virtual"
                    ? "item active_link_color"
                    : "item"
                }
              >
                Race To 17
              </span>
            </Link>
          </li>

          <li>
            <Link
              className={pageName == "race20-virtual" ? "active_link" : ""}
              to="/tp-studio/race20-virtual"
            >
              <span
                className={
                  pageName == "race20-virtual"
                    ? "item active_link_color"
                    : "item"
                }
              >
                Race 20-20
              </span>
            </Link>
          </li>

          <li>
            <Link
              className={pageName == "highcard-virtual" ? "active_link" : ""}
              to="/tp-studio/highcard-virtual"
            >
              <span
                className={
                  pageName == "highcard-virtual"
                    ? "item active_link_color"
                    : "item"
                }
              >
                High Card
              </span>
            </Link>
          </li>
          <li>
            <Link
              className={pageName == "casinowar-virtual" ? "active_link" : ""}
              to="/tp-studio/casinowar-virtual"
            >
              <span
                className={
                  pageName == "casinowar-virtual"
                    ? "item active_link_color"
                    : "item"
                }
              >
                Casino War
              </span>
            </Link>
          </li>
          <li>
            <Link
              className={
                pageName == "lucky7second-virtual" ? "active_link" : ""
              }
              to="/tp-studio/lucky7second-virtual"
            >
              <span
                className={
                  pageName == "lucky7second-virtual"
                    ? "item active_link_color"
                    : "item"
                }
              >
                Lucky 7
              </span>
            </Link>
          </li>
          <li>
            <Link
              className={pageName == "centercard-virtual" ? "active_link" : ""}
              to="/tp-studio/centercard-virtual"
            >
              <span
                className={
                  pageName == "centercard-virtual"
                    ? "item active_link_color"
                    : "item"
                }
              >
                Center Card
              </span>
            </Link>
          </li>

          <li>
            <Link
              className={pageName == "trio" ? "active_link" : ""}
              to="/tp-studio/trio"
            >
              <span
                className={
                  pageName == "trio" ? "item active_link_color" : "item"
                }
              >
                TRIO
              </span>
            </Link>
          </li>
          <li>
            <Link
              className={pageName == "trap" ? "active_link" : ""}
              to="/tp-studio/trap"
            >
              <span
                className={
                  pageName == "trap" ? "item active_link_color" : "item"
                }
              >
                TRAP
              </span>
            </Link>
          </li>

          <li>
            <Link
              className={pageName == "one-card2020" ? "active_link" : ""}
              to="/tp-studio/one-card2020"
            >
              <span
                className={
                  pageName == "one-card2020" ? "item active_link_color" : "item"
                }
              >
                One Card 20-20
              </span>
            </Link>
          </li>

          <li>
            <Link
              className={pageName == "one-card-meter" ? "active_link" : ""}
              to="/tp-studio/one-card-meter"
            >
              <span
                className={
                  pageName == "one-card-meter"
                    ? "item active_link_color"
                    : "item"
                }
              >
                One Card Meter
              </span>
            </Link>
          </li>
          <li>
            <Link
              className={pageName == "queenrace" ? "active_link" : ""}
              to="/tp-studio/queenrace"
            >
              <span
                className={
                  pageName == "queenrace" ? "item active_link_color" : "item"
                }
              >
                Queen Race
              </span>
            </Link>
          </li>

          <li>
            <Link
              className={pageName == "duskadum-virtual" ? "active_link" : ""}
              to="/tp-studio/duskadum-virtual"
            >
              <span
                className={
                  pageName == "duskadum-virtual"
                    ? "item active_link_color"
                    : "item"
                }
              >
                Dus Ka Dum
              </span>
            </Link>
          </li>

          <li>
            <Link
              className={pageName == "side-bet-city" ? "active_link" : ""}
              to="/tp-studio/side-bet-city"
            >
              <span
                className={
                  pageName == "side-bet-city"
                    ? "item active_link_color"
                    : "item"
                }
              >
                Side Bet City
              </span>
            </Link>
          </li>

          <li>
            <Link
              className={pageName == "lottery" ? "active_link" : ""}
              to="/tp-studio/lottery"
            >
              <span
                className={
                  pageName == "lottery" ? "item active_link_color" : "item"
                }
              >
                Lottery
              </span>
            </Link>
          </li>

          <li>
            <Link
              className={pageName == "head-tail" ? "active_link" : ""}
              to="/tp-studio/head-tail"
            >
              <span
                className={
                  pageName == "head-tail" ? "item active_link_color" : "item"
                }
              >
                Head Tail
              </span>
            </Link>
          </li>

          <li>
            <Link
              className={pageName == "fortunegems" ? "active_link" : ""}
              to="/tp-studio/fortunegems"
            >
              <span
                className={
                  pageName == "fortunegems" ? "item active_link_color" : "item"
                }
              >
                Fortune Gems
              </span>
            </Link>
          </li>
          {/*

                  <li>
                    <Link class="" to="/tp-studio/color-game">
                      <span class="item">Color Game</span>
                    </Link>
                  </li>

                  <li>
                    <Link class="" to="/tp-studio/roll-dice">
                      <span class="item">Roll Dice</span>
                    </Link>
                  </li>
*/}
        </ul>
      </div>

      {/*
<div
class="sidebar"
style={{ left: displaySidebar ? "0px" : "-250px" }}
>
<div class="sidebar-content">
  <ul>
    <li>
      <Link class="" to="/tp-studio/roulette">
        <span class="item">Roulette</span>
      </Link>
    </li>
    <li>
      <Link class="" to="/tp-studio/aviator">
        <span class="item">Aviator</span>
      </Link>
    </li>
    <li>
      <Link class="" to="/tp-studio/blastoff">
        <span class="item">BlastOff</span>
      </Link>
    </li>
    <li>
      <Link class="" to="/tp-studio/tp20-virtual">
        <span class="item">TeenPatti T20</span>
      </Link>
    </li>

    <li>
      <Link class="" to="/tp-studio/teenpatti-muflis">
        <span class="item">Muflis TeenPatti</span>
      </Link>
    </li>
    <li>
      <Link class="" to="/tp-studio/sicbo-virtual">
        <span class="item">Sic-Bo</span>
      </Link>
    </li>
    <li>
      <Link class="" to="/tp-studio/andarbahar-virtual">
        <span class="item">AndarBahar</span>
      </Link>
    </li>
    <li>
      <Link class="" to="/tp-studio/hilo">
        <span class="item">HiLo</span>
      </Link>
    </li>
    <li>
      <Link class="" to="/tp-studio/dt-virtual">
        <span class="item">DragonTiger</span>
      </Link>
    </li>
    <li>
      <Link class="" to="/tp-studio/lucky7-virtual">
        <span class="item">7UpDown</span>
      </Link>
    </li>
    <li>
      <Link class="" to="/tp-studio/aaa-virtual">
        <span class="item">Ammar Akbar Anthony</span>
      </Link>
    </li>

    <li>
      <Link class="" to="/tp-studio/card32-virtual">
        <span class="item">32 Cards</span>
      </Link>
    </li>
    <li>
      <Link class="" to="/tp-studio/bollywood-virtual">
        <span class="item">Bollywood Casino</span>
      </Link>
    </li>
    <li>
      <Link class="" to="/tp-studio/race17-virtual">
        <span class="item">Race To 17</span>
      </Link>
    </li>

    <li>
      <Link class="" to="/tp-studio/highcard-virtual">
        <span class="item">High Card</span>
      </Link>
    </li>
    <li>
      <Link class="" to="/tp-studio/casinowar-virtual">
        <span class="item">Casino War</span>
      </Link>
    </li>
    <li>
      <Link class="" to="/tp-studio/lucky7-second-virtual">
        <span class="item">Lucky 7</span>
      </Link>
    </li>
  </ul>
</div> </div>*/}
    </div>
  );
}
